import React from 'react';
import { NavLink } from 'react-router-dom';
import ReactPlayer from 'react-player';

var bgimg1 = require('./../../images/azim/5.webp');

class About3 extends React.Component {
    render() {
        return (
            <>
                <div className={`${this.props.bgcolor} section-full mobile-page-padding p-t80 p-b50`}>
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12">
                                    <div className="about-home-3 m-b30 bg-white">
                                        <h3 className="m-t0 m-b20 sx-tilte">What Azim Facilities Do</h3>
                                        <p>We provide highly trained and professional hospitality staff, including butlers, captains, bartenders, waiters/waitresses, hosts/hostesses, and commis personnel. Our team delivers exceptional service, ensuring a refined and seamless guest experience for hotels, events, and luxury venues.</p>
                                        <ul class="list-angle-right anchor-line two-column-list">
  <li>Butlers</li>
  <li>Captains</li>
  <li>Bartenders</li>
  <li>Waiters/Waitresses</li>
  <li>Hosts/Hostesses</li>
  <li>Commis personnel</li>
</ul>
<style>{`
.two-column-list {
  columns: 2; /* splits list into 2 columns */
  column-gap: 40px;
  list-style-position: inside;
}

`}</style>
                                        <div className="text-left">
                                            <NavLink to="/about" className="site-button btn-half"><span>Read about our facilities management services</span></NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12">
                                    <div className="video-section-full-v2">
                                        <div className="video-section-full bg-no-repeat bg-cover bg-center overlay-wraper m-b30" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                            <div className="overlay-main " />
                                            {/* <div className="video-section-inner">
                                                <div className="video-section-content">
                                                    <NavLink to={"#"} className="play-now" data-toggle="modal" data-target="#myModal">
                                                        <i className="icon fa fa-play" />
                                                        <span className="ripple" />
                                                    </NavLink>

                                                    <div className="video-section-bottom">
                                                        <h3 className="sx-title text-white">25 Years<br />Experience</h3>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="myModal" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <ReactPlayer url='https://vimeo.com/34741214' />
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default About3;